import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ApiCore } from 'src/app/config/api';
import { ApiService } from 'src/app/core/http/api.service';
import { ShareOrderGamesService } from 'src/app/shared/services/shareOrderGames.service';

@Component({
  selector: 'app-main-menu-mobile',
  templateUrl: './main-menu-mobile.component.html',
  styleUrls: ['./main-menu-mobile.component.css'],
})
export class MainMenuMobileComponent implements OnInit, OnDestroy {
  @Output() toggle = new EventEmitter<boolean>();
  public model: MenuItem[] = [];
  public showMenu: boolean = false;
  public currentRoute: string = '';
  private routeSub!: Subscription;
  @Input() social_networks: any = [];
  @Input() show: boolean = false;
  constructor(
    private readonly router: Router,
    private readonly apiService: ApiService,
    private readonly shareOrderGamesService: ShareOrderGamesService
  ) {
    this.shareOrderGamesService.getCategories().subscribe(listCategories => {
      if (listCategories && listCategories.statusCode == 200 && listCategories.data) {
        const menuItems: any = [];

        listCategories.data.forEach((cat: any) => {
          menuItems.push({
            label: cat,
            icon: 'fas fa-lock',
            routerLink: '/app/home/all-games/' + cat,
          });
        });

        this.model = menuItems;
      }
    });
  }

  ngOnInit(): void {
    this.currentRoute = this.router.url;
    this.routeSub = this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
    });
  }
  ngOnDestroy(): void {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

  isActive(route: string): boolean {
    return this.currentRoute.includes(route);
  }

  getGameCategories = () => {
    this.apiService.list(ApiCore.LOBBY_PUBLIC_GAME_CAT).subscribe({
      next: (res) => {
        const menuItems: any = [];

        res.data.forEach((cat: any) => {
          menuItems.push({
            label: cat.name,
            icon: 'fas fa-lock',
            routerLink: '/app/home/all-games/' + cat.name,
          });
        });

        this.model = menuItems;
      },
      error: (err: string) => console.error(err),
    });
  };
  toggleMenu() {
    this.showMenu = !this.showMenu;
  }
  goToCategory(routeLink: string) {
    this.showMenu = false;
    this.router.navigate([routeLink]);
    this.toggle.emit()
  }
}
